<template>
    <div class="col-xs-12 col-sm-12 col-md-12" id="user-edit">
        <form v-on:submit.prevent id="edit_user_form" class="form-horizontal edit-form">
            <div>
                <div class="row justify-content-center">
                    <div class="col-lg-8 text-left">
                        <h4 class="text-left main-title">Enter User Info</h4>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-lg-4 text-left">
                        <label for="first_name" class="control-label form-item">First Name<span style="color: #c95959">*</span></label>
                        <input v-model="first_name" id="first_name" type="text" class="form-control form-item" name="first_name" autofocus>
                    </div>
                    <div class="col-lg-4 text-left">
                        <label for="last_name" class="control-label form-item">Last Name<span style="color: #c95959">*</span></label>
                        <input v-model="last_name" id="last_name" type="text" class="form-control form-item" name="last_name">
                    </div>
                </div>

                <div class="row justify-content-center mt-4">
                    <div class="col-lg-4 text-left">
                        <label for="email" class="control-label form-item">E-mail<span style="color: #c95959">*</span></label>
                        <input v-model="email" id="email" type="email" class="form-control form-item" name="email">
                    </div>
                    <div class="col-lg-4 text-left">
                        <label class="control-label form-item">User Type</label>
                        <span id="user-type-picker">
                            <v-select v-model="user_type_id" :reduce="user_type => user_type.id" label="name" :options="user_types"></v-select>
                        </span>
                    </div>
                </div>

                <div class="row justify-content-center mt-2">
                    <div class="col-lg-8 text-right user-types">
                        <span class="inline-block">User Types and Definitions</span>
                        <a @click="toggleUserTypesAndDefinitions"  class="user-types-link">{{ user_types_and_definitions ? 'hide' : 'show' }}</a>
                    </div>
                </div>

                <div class="form-group row justify-content-center">
                    <div :class="{ 'active': user_types_and_definitions }" class="col-md-8 user-types-and-definitions-container">
                        <table class="table table-bordered text-left">
                            <thead>
                                <tr>
                                    <th>User Type</th>
                                    <th>Access includes</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="user_type in user_types">
                                    <td>{{ user_type.name }}</td>
                                    <td>{{ user_type.definition }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Removing the weekly and monthly emails selections -->
                <!-- <div v-if="['owner', 'super_admin'].indexOf(user_types_by_id[user_type_id]) > -1" class="row justify-content-center mt-2 margin-bottom30">
                    <div class="col-lg-8 text-left">
                        <h4 class="text-left main-title">Email Excel Reports</h4>

                        <p-input type="checkbox" v-model="user.email_excel_report_weekly" class="p-default p-curve single" value="weekly">Weekly</p-input>
                        <p-input type="checkbox" v-model="user.email_excel_report_monthly" class="p-default p-curve single" value="monthly">Monthly</p-input>
                    </div>
                </div> -->

                <div class="form-group row justify-content-center clients-permissions">
                    <template v-if="has_clients">
                        <div class="col-md-8">
                            <h4 class="text-left mt-1 main-title">Choose which clients this user has access to</h4>
                        </div>
                        <div class="col-md-8 mb-3">
                            <label><p-input type="checkbox" class="p-switch p-slim clients-all" @change="selectAllClients" v-model="allCheck" :disabled="disableClientCheck">Select all</p-input></label>
                        </div>
                        <div class="col-md-8">
                            <div class="row client-table-wrap item-table-wrap" id="clients_table_wrap">
                                <div v-for="(client, index) in clients" class="col-12 col-sm-6 col-lg-4 col-xl-3 text-left">
                                    <label class="user-label">
                                        <p-input type="checkbox" v-model="client.checked" class="p-default p-curve users clients single" name="selected_clients[]" @change="checkAll" :value="client.id" :disabled="disableClientCheck">{{ client.name }}</p-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>

                <div class="row justify-content-center mt-5">
                    <div class="col-md-12 text-center">
                        <button ref="save_changes_button" data-loading-text='<span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>Saving...'
                                @click="saveUser" id="save_user"
                                type="submit" class="btn btn-secondary"
                                style="pointer-events:initial !important;">Save Changes</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },

        updated() {
            if (this.$refs.select_all_clients) {
                this.$refs.select_all_clients.checked = $('#clients_table_wrap').find('input:checked').length === this.original_form_data.clients.length;
            }
            if ( document.getElementById('user-type-picker-selector') ) {
                 var selectedElIndex = document.getElementById('user-type-picker-selector').selectedIndex;
                 this.userTypeInnerHTML = document.getElementById('user-type-picker-selector').options[selectedElIndex].text;
            }

            this.validateForm();
        },

        mounted() {
            const vueInstance = this;

            $('#edit_user_form').on('submit', function() {
                if(vueInstance.submitted == true) return;
                vueInstance.submitted = true;
                vueInstance.validateSubmit();
                $(this).ajaxSubmit({
                    method: 'PUT',
                    url:window.app_url + '/api/users/' + vueInstance.$route.params.id,
                    data: {
                        user_type_id:               vueInstance.user_type_id || null,
                        email_excel_report_weekly:  vueInstance.user.email_excel_report_weekly,
                        email_excel_report_monthly: vueInstance.user.email_excel_report_monthly
                    },
                    success(response) {
                        if (parseInt(vueInstance.$route.params.id) === vueInstance.$store.state.auth_user.id) {
                            axios.get('/api/users/auth_user').then(function(response) {
                                vueInstance.$store.commit('setAuthUser', response.data);
                                vueInstance.$root.$refs.top_right_menu_text.innerHTML =
                                    response.data.first_name + ' ' + response.data.last_name +
                                    '<span class="caret"></span>';
                            });
                        }

                        vueInstance.notification(vueInstance.messages.USER_UPDATED);
                        vueInstance.$router.push({path: '/users'});
                    },
                    complete() {//both success or error
                        vueInstance.submitted = false;
                        vueInstance.validateSubmit();
                    }
                    //error case is managed globally, in bootstrap.js
                });
            });
        },

        data() {
            return {
                has_clients:false,
                original_form_data: {},
                allCheck: false,
                all_clients_checked: false,
                disableClientCheck:false,
                user:       {},
                clients:    [],
                user_types: [],
                user_type_id:1,
                user_types_by_id:{0:'owner'},
                userTypeInnerHTML: '',
                first_name:                     null,
                last_name:                      null,
                email:                          null,
                user_types_and_definitions:     false,
                save_changes_button_disabled:   true,
                submitted:                      false
            }
        },

        methods: {
            selectAllClients(event) {
                _.each(this.clients, function(client) {
                    client.checked = event;
                });
                this.validateForm();
            },

             checkAll(event){
                if($('.clients-permissions .single > input').length == $('.clients-permissions .single > input:checked').length){
                    this.allCheck = true;
                }
                else{
                    this.allCheck = false;
                }

                this.validateForm();
            },

            fetchServerData() {
                const params = $.param({
                    user_id:   this.$route.params.id,
                    with_data: ['user_permission']
                });

                axios.all([
                    axios.get('/api/clients?' + params),
                    axios.get('/api/users/' + this.$route.params.id),
                    axios.get('/api/users/types')
                ])
                .then(axios.spread((clients, user, userTypes) => {
                    this.clients        = clients.data;
                    this.has_clients    = clients.data.length;
                    this.user           = user.data;
                    this.user_type_id   = user.data.user_type_id;
                    this.user_types     = userTypes.data;
                    this.user.user_type = this.user.user_type_name.toLowerCase();

                    this.first_name      = user.data.first_name;
                    this.last_name       = user.data.last_name;
                    this.email           = user.data.email;


                    this.saveOriginalFormData(user, clients);
                    this.allCheck = clients.data.every(client => client.checked == true );

                    if(!user.data.owner_id || !this.user_type_id){
                        this.allCheck = true;
                        this.disableClientCheck = true;
                    }

                    if(this.$store.state.auth_user.original.id == this.user.id){
                        this.disableClientCheck = true;
                    }

                    var userTypesArr = userTypes.data.map(user_type => {
                        return {id: user_type.id, value: user_type.name}
                    })

                    var filteredUsers = userTypesArr.filter( user => {
                        return user.value.toLowerCase() !== 'owner';
                    });

                    _.each(this.user_types, (user_type) => {
                        this.user_types_by_id[user_type.id] = user_type.short_name;
                    });
                }));
            },

            saveOriginalFormData(user, clients) {
                this.original_form_data.clients                    = vm.customClone(clients.data);
                this.original_form_data.first_name                 = user.data.first_name;
                this.original_form_data.last_name                  = user.data.last_name;
                this.original_form_data.email                      = user.data.email;
                this.original_form_data.user_type_id               = user.data.user_type_id;
                this.original_form_data.email_excel_report_weekly  = user.data.email_excel_report_weekly;
                this.original_form_data.email_excel_report_monthly = user.data.email_excel_report_monthly;
            },

            validateForm() {
                let disabled = true;
                if (
                    (this.submitted == false) &&
                    (
                        (this.original_form_data.first_name != this.first_name)
                        || (this.original_form_data.last_name != this.last_name)
                        || (this.original_form_data.email != this.email)
                        || (this.original_form_data.user_type_id != this.user_type_id)
                        || (this.original_form_data.email_excel_report_weekly != this.user.email_excel_report_weekly)
                        || (this.original_form_data.email_excel_report_monthly != this.user.email_excel_report_monthly)
                    )
                ) {
                    disabled = false;
                }

                const currentSelectedClients = document.querySelectorAll('#clients_table_wrap input');
                if (currentSelectedClients.length) {
                    _.each(this.original_form_data.clients, function(client, i) {
                        if (!!client.checked !== currentSelectedClients[i].checked) {
                            disabled = false;

                            return false;
                        }
                    });
                }

                if (this.$refs.save_changes_button) {
                    this.$refs.save_changes_button.disabled = disabled;
                }

                this.save_changes_button_disabled = disabled;
            },
            validateSubmit(){
                this.$refs.save_changes_button.disabled = this.submitted;
            },
            blur_after_change(event){
                $(event.target).closest('.form-group').find('*').blur();
            },
            toggleUserTypesAndDefinitions() {
                this.user_types_and_definitions = !this.user_types_and_definitions;
            },
            saveUser() {
                if(this.submitted == true) return;
                this.submitted = true;
                $('#save_user').button('loading');

                let formData = new FormData;
                formData.append('first_name', this.first_name);
                formData.append('last_name', this.last_name || '');
                formData.append('email', this.email || '');
                formData.append('user_type_id', this.user_type_id || 1);
                formData.append('selected_clients', this.clients.length ? JSON.stringify(this.clients) : '');
                formData.append('user_types_and_definitions', this.user_types_and_definitions || false);
                formData.append('email_excel_report_weekly', this.email_excel_report_weekly || false);
                formData.append('email_excel_report_monthly', this.email_excel_report_monthly || false);
                formData.append('_method', 'PUT');

                this.ajaxSubmit({'Content-Type': 'multipart/form-data'}, 'POST', `/api/users/${this.$route.params.id}`, formData).then(response => {
                    $('#save_user').button('reset');

                    this.$notify({
                        type: 'success',
                        text: this.messages.USER_UPDATED
                    });

                    this.submitted = false;
                    this.$router.push({path: '/users'});
                });
            }
        },
        watch:{
            user_type_id(value){
                if(['owner', 'super_admin'].indexOf(this.user_types_by_id[value]) === -1){
                    this.user.email_excel_report_weekly = false;
                    this.user.email_excel_report_monthly = false;
                }
            }
        }
    }
</script>
<style lang="scss">
    @import '~@/_variables.scss';
    #user-edit{
        .inline-block {
            display: inline-block;
        }

        .user-types {
            font-size: 1.28rem;
        }
        .user-types-link {
            cursor: pointer;
            font-weight: 500;
        }

        th {
            font-weight: 500;
        }
        .main-title {
            padding-left: 0;
            margin-bottom: 2rem;
        }
        .user-types-and-definitions-container {
            display:flex;
            justify-content:right;
            max-height: 0;
            transition: max-height .25s ease-out;
            overflow: hidden;

            &.active {
                max-height: 80rem;
                transition: max-height .25s ease-in;
            }
        }
        table {
            width: auto;
            font-size: 1.2rem;
        }
        div.bootstrap-select{
            button.dropdown-toggle{

            }
            div.dropdown-menu{
                &.open{
                    min-width:35.2rem;
                    width: 100%;
                }
            }
        }
        button:disabled{
            cursor:not-allowed;
            &:hover{
                color:white;
            }
        }
        .pretty.p-default input:checked ~ .state label::after {
            background-color:$secondary !important;
        }
        .pretty.p-switch input:checked ~ .state label::after {
            background-color:$secondary !important;
        }
        .pretty{
            line-height:1 !important;
        }
    }
</style>
